var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spot empty",class:_vm.draging ? 'drag-over' : '',on:{"dragover":_vm.dragOver,"dragenter":function($event){_vm.draging = !_vm.uploading},"dragleave":function($event){_vm.draging = false},"drop":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onDrop($event)}}},[_c('h2',{staticClass:"title"},[_vm._v("Odloži slike tukaj")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-770d96f6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DropSpot.vue
// module id = null
// module chunks = 